import * as React from "react";
import * as ReactDOM from "react-dom";
import { Input, InputNumber } from "antd";
import BaseComponent from "src/engine/ui/BaseComponent";
import UIInject, { IHandle } from "../UIInject";
import UIManifest from "src/engine/ui/UIManifest";
import IUIItem from "src/engine/interface/IUIItem";
import AutoBind from "src/engine/decorator/AutoBind";
import SyncUtils from "src/engineEditor/props/SyncUtils";

const { TextArea, Search, Group, Password } = Input;

interface IAntInput {
    uiItem: IUIItem;
    onChange?: any;
    onBlur?: any;
    value?: string;
    defaultValue?: string;
    type?: "TextArea" | "Input" | "Search" | "Group" | "Password" | "InputNumber" | "Hidden";
    max?: string | number;
    maxLength?: string | number;
    onChangeType?: "onChange" | "onBlur";
    syncTime?: number;
    onFocus?: any;
    openKeyboard?: boolean;
}

interface IState {
    value?: any;
}

const isChrome = !!(window as any).chrome;
@UIManifest.declareGG(["ggValue"], "AntInput", "Input输入框", UIManifest.Type.AntD)
class AntInput extends BaseComponent<IAntInput, IState> {
    /**
     * 解决输入中文时bug
     */
    isOnComposition: boolean = false;

    mSyncUtils = new SyncUtils(this.props.syncTime || 200);

    constructor(props: IAntInput) {
        super(props);
        this.state = { value: props.value || props.defaultValue };
    }

    onChange = (e: any) => {
        const { type = "Input" } = this.props as any;
        let value = e;

        if (type === "InputNumber") {
            value = e;
        } else {
            value = e.target.value;
        }
        this.setState({ value });
        if (!this.isOnComposition || !isChrome) {
            this.onChangeACt(value);
        }
    };

    onBlur = () => {
        const { onChangeType = "onChange" } = this.props;
        if (onChangeType === "onBlur") this.props.onChange?.(this.state.value);
        if (this.props.onBlur) {
            this.props.onBlur(this.state.value);
        }
    };

    onChangeACt(value: any) {
        const { onChangeType = "onChange" } = this.props;
        if (onChangeType === "onChange")
            this.mSyncUtils.sync("value", () => {
                this.props.onChange?.(value);
            });
    }

    static getDerivedStateFromProps(nextProps: IAntInput, state: any) {
        if (nextProps.value !== state.oldValue) {
            return { value: nextProps.value, oldValue: nextProps.value };
        }
        return null;
    }

    @AutoBind
    handleComposition(e: any) {
        if (e.type === "compositionend") {
            // composition is end
            this.isOnComposition = false;

            if (!this.isOnComposition && isChrome) {
                // fire onChange
                this.onChange(e);
            }
        } else {
            // in composition
            this.isOnComposition = true;
        }
    }

    @AutoBind
    onFocus(e: any) {
        const { onFocus, openKeyboard } = this.props;
        if (openKeyboard) this.scrollIntoView();
        if (onFocus) onFocus(e);
    }

    inputdom: any;
    inputRef = (ref: any) => {
        this.inputdom = ref;
    };

    scrollIntoView = () => {
        if (!this.inputdom) return;
        const dom: any = ReactDOM.findDOMNode(this.inputdom);
        if (!dom || !dom.scrollIntoViewIfNeeded) return;
        // dom.scrollIntoViewIfNeeded(true);
        // 2345类浏览器在键盘弹出后可视区域不变 直接覆盖在页面上 所以scrollIntoViewIfNeeded不生效
        if (dom.parentElement.className.indexOf("control") >= 0) {
            const parent = dom.parentElement.parentElement;
            if (parent) parent.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    render() {
        const { type = "Input", children, allStyle, _line, _sameUI, onChangeType, ...other } = this.props as any;
        const uiMaps = { TextArea, Input, Search, Group, Password, InputNumber, Hidden: Input };
        const handles: IHandle[] = [];
        if (type === "Hidden") {
            other.type = "hidden";
        }
        return (
            <UIInject
                ui={uiMaps[`${type}`]}
                {...other}
                value={this.state.value}
                onCompositionStart={this.handleComposition}
                onCompositionUpdate={this.handleComposition}
                onCompositionEnd={this.handleComposition}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                handles={handles}
                ref={this.inputRef}
            />
        );
    }
}

export default AntInput;
